export enum RaffleDefaultTicketStatusEnum {
  PENDING = "p",
  AVAILABLE = "a",
  UNAVAILABLE = "u",
}

export type RaffleDefaultTicketStatusTypes =
  `${RaffleDefaultTicketStatusEnum}`;
